import clsx from "clsx";
import s from "./style.module.scss";

export const FlexWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={clsx(s.wrapper, className)}>{children}</div>;
